import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { dbObjectToId, Filter, MUSTNeverHappenException, sortArray } from '@nu-art/ts-common';
import { _className, ComponentSync, LL_V_L, SimpleListAdapter, TS_DropDown, TS_Input } from '@nu-art/thunderstorm-frontend/index';
import { VariableWrapper } from '../../wrappers/index.js';
import { DropDown_MeasurementUnit } from '../../_entity/measurement-unit/ui-components.js';
import { DropDown_Book } from '../../_entity/book/ui-components.js';
import { DropDown_Reference } from '../../_entity/reference/ui-components.js';
import { DropDown_Value } from '../../_entity/value/ui-components.js';
import { DropDown_Tag } from '../../_entity/tag/ui-components.js';
import { DropDown_DefaultCaret } from '@app/styles/frontend/ui/consts';
import { DropDown_Resource } from '../../_entity/resource/ui-components.js';
import { DropDown_Expression } from '../../_entity/expression/ui-components.js';
import { resolveValueDisplay, StaticValues_EnumElements, ValType_IND, valueType_EnumElement, valueType_Enumerated, valueType_StandardRange, valueType_SubRange, valueType_TimeRange, valueType_Tuple } from '@app/hcs-shared';
import { DropDown_VariableV3 } from '../../_entity/variable/ui-components.js';
import { DropDown_LogTemplate_OLD } from '../../_entity/log-template-OLD/index.js';
import { ModuleFE_Value, ModuleFE_Variable } from '../../_entity.js';
export const HCSDropDowns = {
    Variable: DropDown_VariableV3.selectable,
    MeasurementUnit: DropDown_MeasurementUnit.selectable,
    Value: DropDown_Value.selectable,
    Reference: DropDown_Reference.selectable,
    Book: DropDown_Book.selectable,
    Tag: DropDown_Tag.selectable,
    LogTemplate: DropDown_LogTemplate_OLD.selectable,
    Resource: DropDown_Resource.selectable,
    NLPData: () => _jsx(_Fragment, {}),
    VariableRelation: () => _jsx(_Fragment, {}),
    Score: () => _jsx(_Fragment, {}),
    Expression: DropDown_Expression.selectable
};
export const DropDown_Values = (props) => {
    const { variable, ...restOfProps } = props;
    let containerValue = ModuleFE_Value.cache.unique(variable.valueId);
    if (!containerValue)
        throw new MUSTNeverHappenException(`Could not find child value with id ${variable.valueId} for variable with id ${variable._id}`);
    let childrenValueIds = [];
    //Fix for standard range
    if (containerValue?.type === 'standard-range') {
        containerValue = ModuleFE_Value.cache.unique(ValType_IND._id);
        if (!containerValue)
            throw new MUSTNeverHappenException(`Could not find child value with id ${variable.valueId} for variable with id ${variable._id}`);
        childrenValueIds = containerValue.data.scope;
    }
    else {
        childrenValueIds = ModuleFE_Value.getRelatedValues(variable)?.values.map(dbObjectToId);
    }
    return _jsx(HCSDropDowns.Value, { queryFilter: value => childrenValueIds ? childrenValueIds.includes(value._id) : true, caret: DropDown_DefaultCaret, sortBy: [(item) => {
                switch (item.type) {
                    case valueType_SubRange:
                        return item.data.scope[0];
                    case valueType_TimeRange:
                        return resolveValueDisplay(item);
                    case valueType_EnumElement: {
                        // @ts-ignore
                        if (![valueType_Enumerated, valueType_Tuple, valueType_StandardRange].includes(containerValue.type))
                            return item.data.value;
                        const containerValueAsEnumerated = containerValue;
                        if (containerValue.type === valueType_Enumerated) {
                            const valIndex = containerValueAsEnumerated.data.scope.findIndex(val => val === item._id);
                            if (valIndex === -1)
                                return 0;
                            if (containerValueAsEnumerated.data.props?.isOrdered)
                                return valIndex;
                            return (ModuleFE_Value.cache.unique(containerValueAsEnumerated.data.scope[valIndex])?.data).value;
                        }
                        if (containerValue.type === valueType_StandardRange) {
                            return StaticValues_EnumElements.findIndex(value => item._id === value._id);
                        }
                        return item._id;
                    }
                    default:
                        return item.type;
                }
            }], ...restOfProps });
};
//If you use this component without an ancestor to await ModuleFE_Variable, THAT'S ON YOU!
export class DropDown_Variable extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        if (nextProps.queryFilter)
            state.variables = ModuleFE_Variable.cache.filter(nextProps.queryFilter);
        else
            state.variables = ModuleFE_Variable.cache.allMutable();
        if (nextProps.sortBy)
            state.variables = sortArray(state.variables, nextProps.sortBy[0]);
        return state;
    }
    getSelectedItem = () => {
        const selected = this.props.selected;
        switch (typeof selected) {
            case 'function':
                return selected();
            case 'string':
                return ModuleFE_Variable.cache.unique(selected);
            case 'object':
                return selected;
        }
        return undefined;
    };
    render() {
        const className = _className('variable-dropdown', this.props.className);
        const filter = new Filter(i => new VariableWrapper(ModuleFE_Variable.cache.unique(i._id)).getSearchableText());
        const adapter = (filterText) => SimpleListAdapter(this.state.variables, i => _jsxs(LL_V_L, { className: 'node-data', children: [_jsx("span", { className: 'variable-name', children: i.item.name }), filterText &&
                    _jsx("span", { className: 'pass-reason', children: new VariableWrapper(ModuleFE_Variable.cache.unique(i.item._id)).renderVarFilterPassReason(filterText) })] }));
        return _jsx(TS_DropDown, { ...this.props, limitItems: this.props.limitItems ?? 50, className: className, adapter: adapter, selected: this.getSelectedItem(), placeholder: this.props.placeholder ?? 'Select a variable', filter: filter });
    }
}
export class DropDown_VariableAttribute extends ComponentSync {
    static defaultProps = {
        modules: [ModuleFE_Variable]
    };
    deriveStateFromProps(nextProps, state) {
        state = this.state ?? {};
        if (nextProps.queryFilter)
            state.variables = ModuleFE_Variable.cache.filter(nextProps.queryFilter);
        else
            state.variables = ModuleFE_Variable.cache.allMutable();
        if (nextProps.sortBy)
            state.variables = sortArray(state.variables, nextProps.sortBy[0]);
        state.selectedVariable = nextProps.selected.variable;
        state.selectedAttribute = nextProps.selected.attribute;
        return state;
    }
    handleInputChange = (inputValue, dropDown) => {
        if (!inputValue.length)
            this.setState({ selectedAttribute: undefined, selectedVariable: undefined });
        if (inputValue.endsWith('.')) {
            const variableName = inputValue.slice(0, -1);
            const variable = this.state.variables.find(v => v._nameInLowercase === variableName.toLowerCase());
            if (variable) {
                this.setState({ selectingAttribute: true, selectedVariable: variable });
            }
        }
        else {
            const variable = this.state.variables.find(v => v._nameInLowercase === inputValue.toLowerCase());
            if (variable) {
                this.setState({ selectedVariable: variable });
            }
        }
        const splitInput = inputValue.split('.');
        // @ts-ignore
        dropDown.reDeriveState({ filterText: splitInput[splitInput.length - 1] });
    };
    handleSelection = (item) => {
        const _variable = this.state.selectedVariable;
        if (!item || !_variable)
            return;
        if (_variable?._nameInLowercase === item?._nameInLowercase) {
            this.props.onSelected(_variable, 'variable');
            if (this.state.selectingAttribute)
                this.props.onSelected(undefined, 'attribute');
        }
        else {
            this.props.onSelected(_variable, 'variable');
            this.props.onSelected(item, 'attribute');
        }
    };
    renderSelectedItem = () => {
        if (!this.state.selectedAttribute && !this.state.selectedVariable)
            return _jsx("div", { className: "ts-dropdown__placeholder", children: 'Pick A Variable' });
        return _jsx("div", { className: 'ts-dropdown__selected', children: `${this.state.selectedVariable?.name}${this.state.selectedAttribute
                ? `.${this.state.selectedAttribute.name}`
                : ''}` });
    };
    renderSearchInput = (dropDown) => {
        return _jsx(TS_Input, { type: "text", value: dropDown.props.inputValue, onChange: (filterText) => this.handleInputChange(filterText, dropDown), focus: true, style: { width: '100%' }, placeholder: dropDown.props.placeholder || '', onCancel: () => {
                // @ts-ignore
                dropDown.reDeriveState({ open: false, filterText: undefined });
            }, onKeyDown: (e) => {
                // @ts-ignore
                dropDown.inputKeyEventHandler(e);
            } });
    };
    render() {
        const items = this.state.selectingAttribute
            ? this.state.selectedVariable?._attributeVarIds?.map(attrId => ModuleFE_Variable.cache.unique(attrId)) ?? []
            : this.state.variables;
        const filter = new Filter(i => new VariableWrapper(ModuleFE_Variable.cache.unique(i._id)).getSearchableText());
        const adapter = (filterText) => SimpleListAdapter(items, i => _jsxs(LL_V_L, { children: [_jsx("span", { className: 'variable-name', children: i.item?.name }), filterText &&
                    _jsx("span", { className: 'pass-reason', children: new VariableWrapper(ModuleFE_Variable.cache.unique(i.item?._id)).renderVarFilterPassReason(filterText) })] }));
        return _jsx(TS_DropDown, { selectedItemRenderer: this.renderSelectedItem, renderSearch: this.renderSearchInput, limitItems: this.props.limitItems ?? 50, className: 'variable-dropdown', adapter: adapter, filter: filter, selected: this.state.selectedVariable, onSelected: this.handleSelection });
    }
}
export function DropDown_Relations(props) {
    const dropdownValues = [
        'Contains',
        'Member Of',
        'Derivative',
        'Convert To Enum'
    ];
    const generateAdapterList = () => (SimpleListAdapter(dropdownValues, i => _jsx("div", { className: 'node-data', children: _jsx("span", { className: 'variable-name', children: i.item }) })));
    return _jsx(TS_DropDown, { adapter: generateAdapterList(), placeholder: 'Select a relation', selected: props.relation ? props.relation : undefined, onSelected: selectedRelation => props.onSelectRelation(selectedRelation, props.index) });
}
//# sourceMappingURL=app-dropdowns.js.map